import PropTypes from 'prop-types';
import Button from 'components/UI/Button';

const OfferRejectedScreen = ({ literals, onClose }) => (
  <div className='full-screen-container digital-loan-preoffer'>
    <div className='screen-content digital-loan-preoffer__scroll'>
      <h1 className='digital-loan-phase2__title'>{literals.doneTitle}</h1>
      <p className='digital-loan-phase2__body mb-3'>{literals.doneBody}</p>
      <p className='digital-loan-phase2__body'>{literals.doneHint}</p>
    </div>
    <div className='screen-actions'>
      <Button text={literals.doneAction} onClick={onClose} />
    </div>
  </div>
);

OfferRejectedScreen.propTypes = {
  literals: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default OfferRejectedScreen;
